/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_NextInputs */

const en_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming up`)
};

const de_today_next = /** @type {(inputs: Today_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Nächstes`)
};

/**
* | output |
* | --- |
* | "Coming up" |
*
* @param {Today_NextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const today_next = /** @type {((inputs?: Today_NextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_NextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_today_next(inputs)
	return en_today_next(inputs)
});